import { useState } from 'react';
import type { ReactNode } from 'react';
import Icon from '@/components/Icon/Icon';
import { Text } from '@/components/Typography/Text';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/cn';
import { HStack } from '../Layout';
type ToggleHelpTextProps = {
  title: string;
  className?: string;
  children: ReactNode;
  defaultOpen?: boolean;
  /**
   * 展開時もタイトルを表示し、本文をその下に積む。
   * 未指定時は従来どおり展開中は children のみ表示する。
   */
  keepTitleWhenExpanded?: boolean;
};
export function ToggleHelpText({
  title,
  className,
  children,
  defaultOpen = false,
  keepTitleWhenExpanded = false
}: ToggleHelpTextProps) {
  const [open, setOpen] = useState(defaultOpen);
  const handleToggle = () => {
    setOpen(!open);
  };
  return <Button variant="ghost" className={cn('relative block h-auto w-full justify-start overflow-visible whitespace-normal hover:bg-transparent', className)} onClick={handleToggle}>
      <HStack className={cn('items-start justify-start')}>
        <Icon iconName="ChevronDownIcon" className={cn('mx-[10px] mt-0.5 transition-transform', keepTitleWhenExpanded && 'shrink-0', open ? '' : '-rotate-90')} />
        {keepTitleWhenExpanded ? <div className="mt-0 flex flex-col items-start gap-1.5 text-left">
            <Text variant="pSmall" className="font-semibold text-neutral-muted-on-fill">
              {title}
            </Text>
            {open ? children : null}
          </div> : <div className="mt-0">{open ? children : title}</div>}
      </HStack>
    </Button>;
}